//Importaciones
import React from 'react'
import { Link, MessageBar, MessageBarButton, MessageBarType } from '@fluentui/react';
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';

function MessageBox(props) {
    //Helpers
    const { t } = useTranslation();

    //Parametros de entrada.
    const { inputParam_Message = null,
        inputParam_MessageType = null,
        inputParam_Display = false,
        inputParam_SetterMessage = null,
        inputParam_OnCloseExtender = null,
        inputParam_Width = "100%",
        inputParam_UseCustomAction = false,
        inputParam_CustomActionFucntion = null,
        inputParam_Position = null,

        inputParam_MessageLinkFunction = null,
        inputParam_MessageLink = null
    } = props;

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.
    const onCloseSuccessMessageBar = () => {
        inputParam_SetterMessage && inputParam_SetterMessage(prevState => ({
            ...prevState,
            showMessage : false,
        }));

        inputParam_OnCloseExtender && inputParam_OnCloseExtender();
    }

    //Render de componente.
    return (
        <div style={ { position: inputParam_Position ? inputParam_Position: 'unset', zIndex: 2, width: inputParam_Width, display: `${inputParam_Display ? "inline-block" : "none"}` } }>
            <MessageBar                
                dismissButtonAriaLabel={ t('data-lang-lbl-close') }
                isMultiline={!inputParam_UseCustomAction}
                messageBarType={ inputParam_MessageType === "success" ? MessageBarType.success : (inputParam_MessageType === "error" ? MessageBarType.error : (inputParam_MessageType === "warning" ? MessageBarType.warning : MessageBarType.info)) }
                actions={ inputParam_UseCustomAction ?
                    <div>
                        <MessageBarButton onClick={inputParam_CustomActionFucntion}>{t('data-lang-lbl-view')}</MessageBarButton>
                    </div> : undefined
                }
                onDismiss={ ()=> onCloseSuccessMessageBar() }>
                { t(inputParam_Message) }
                {
                    inputParam_MessageLink && !Array.isArray(inputParam_MessageLink) &&
                    <>
                        <Link className='ps-1' onClick={inputParam_MessageLinkFunction}>{inputParam_MessageLink}</Link>.
                    </>
                }
                {
                    inputParam_MessageLink && Array.isArray(inputParam_MessageLink) && inputParam_MessageLink.map((item, index) => 
                        <Link key={index} className='px-1' onClick={item.linkFunc}>{item.text}</Link>
                    )
                }
            </MessageBar>
        </div>
    );
}

///Proptypes
MessageBox.propTypes = {
    inputParam_Width: PropTypes.string,
    inputParam_Message: PropTypes.string,
    inputParam_MessageType: PropTypes.string,
    inputParam_Display: PropTypes.bool.isRequired,
    inputParam_SetterMessage: PropTypes.func.isRequired,
    inputParam_OnCloseExtender: PropTypes.func,
    inputParam_UseCustomAction: PropTypes.bool,
    inputParam_CustomActionFucntion: PropTypes.func,
    inputParam_Position: PropTypes.string,

    inputParam_MessageLinkFunction: PropTypes.func,
};

export default MessageBox;